<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-企业-修改
    -->
    <el-dialog
    title="修改企业"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="150px">
      <div class="common-form">修改企业</div>

      <el-form-item label="企业名称" prop="name"><el-input v-model="form.name" placeholder="请输入企业名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="组织类型" prop="organization_type">
        <el-radio-group v-model="form.organization_type">
          <el-radio label="企业">企业</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="监管平台主账号" prop="main_account"><el-input v-model="form.main_account" placeholder="请输入监管平台主账号" class="max-w460"></el-input></el-form-item>

      <el-divider content-position="left">道路运输经营许可证</el-divider>

      <el-form-item label="上传道路运输经营许可证" prop="transport_license_image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.transport_license_image">
            <transition-group>
              <div v-for="(item, index) in form.transport_license_image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'transport_license_image')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('transport_license_image')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="道路运输许可证件号" prop="transport_license_no"><el-input v-model="form.transport_license_no" placeholder="请输入道路运输许可证件号" class="max-w460"></el-input></el-form-item>

      <el-form-item label="有效期开始时间" prop="transport_license_validity_start"><el-date-picker v-model="form.transport_license_validity_start" type="date" placeholder="选择有效期开始时间" value-format="yyyy-MM-dd" style="width: 300px;"></el-date-picker></el-form-item>

      <el-form-item label="有效期截止时间" prop="transport_license_validity_end"><el-date-picker v-model="form.transport_license_validity_end" type="date" placeholder="选择有效期截止时间" value-format="yyyy-MM-dd" style="width: 300px;"></el-date-picker></el-form-item>

      <el-form-item label="发证日期" prop="transport_license_issue_date"><el-date-picker v-model="form.transport_license_issue_date" type="date" placeholder="选择发证日期" value-format="yyyy-MM-dd" style="width: 300px;"></el-date-picker></el-form-item>

      <el-form-item label="道路运输经营范围" prop="transport_license_scope"><el-input v-model="form.transport_license_scope" type="textarea" :rows="3" placeholder="请输入道路运输经营范围" class="max-w460"></el-input></el-form-item>

      <el-divider content-position="left">营业执照</el-divider>

      <el-form-item label="上传营业执照" prop="business_license_image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.business_license_image">
            <transition-group>
              <div v-for="(item, index) in form.business_license_image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'business_license_image')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('business_license_image')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="营业执照名称" prop="business_license_name"><el-input v-model="form.business_license_name" placeholder="请输入营业执照名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="注册资本" prop="registered_capital"><el-input v-model="form.registered_capital" placeholder="请输入注册资本" class="max-w460"></el-input></el-form-item>

      <el-form-item label="统一社会信用代码" prop="credit_code"><el-input v-model="form.credit_code" placeholder="请输入统一社会信用代码" class="max-w460"></el-input></el-form-item>

      <el-form-item label="类型" prop="company_type">
        <el-cascader
          v-model="form.company_type"
          :options="companyTypeOptions"
          :props="cascaderProps"
          placeholder="请选择类型"
          style="width: 300px;"
          clearable
          filterable
        ></el-cascader>
      </el-form-item>

      <el-form-item label="成立日期" prop="establishment_date"><el-date-picker v-model="form.establishment_date" type="date" placeholder="选择成立日期" value-format="yyyy-MM-dd" style="width: 300px;"></el-date-picker></el-form-item>

      <el-form-item label="有效开始日期" prop="valid_start_date"><el-date-picker v-model="form.valid_start_date" type="date" placeholder="选择有效开始日期" value-format="yyyy-MM-dd" style="width: 300px;"></el-date-picker></el-form-item>

      <el-form-item label="有效截止日期" prop="valid_end_date"><el-date-picker v-model="form.valid_end_date" type="date" placeholder="选择有效截止日期" value-format="yyyy-MM-dd" style="width: 300px;"></el-date-picker></el-form-item>

      <el-form-item label="法定代表人" prop="legal_representative"><el-input v-model="form.legal_representative" placeholder="请输入法定代表人" class="max-w460"></el-input></el-form-item>

      <el-form-item label="法定代表电话" prop="legal_phone"><el-input v-model="form.legal_phone" placeholder="请输入法定代表电话" class="max-w460"></el-input></el-form-item>

      <el-form-item label="法人身份证号" prop="legal_id_card"><el-input v-model="form.legal_id_card" placeholder="请输入法人身份证号" class="max-w460"></el-input></el-form-item>

      <el-form-item label="安全负责人" prop="safety_manager"><el-input v-model="form.safety_manager" placeholder="请输入安全负责人" class="max-w460"></el-input></el-form-item>

      <el-form-item label="安全负责人电话" prop="safety_manager_phone"><el-input v-model="form.safety_manager_phone" placeholder="请输入安全负责人电话" class="max-w460"></el-input></el-form-item>

      <el-form-item label="组织名称" prop="organization_name"><el-input v-model="form.organization_name" placeholder="请输入组织名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="简称" prop="short_name"><el-input v-model="form.short_name" placeholder="请输入简称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="省市区" prop="region">
        <div style="display: flex;">
          <el-select @change="provinceChange" v-model="form.province_name" filterable placeholder="请选择省份" style="width: 150px; margin-right: 10px;">
            <el-option
              v-for="item in province_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <el-select @change="cityChange" v-model="form.city_name" filterable placeholder="请选择城市" :disabled="lock_city" style="width: 150px; margin-right: 10px;">
            <el-option
              v-for="item in city_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <el-select @change="regionChange" v-model="form.region_name" filterable placeholder="请选择区域" :disabled="lock_region" style="width: 150px;">
            <el-option
              v-for="item in region_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item label="营业执照住所" prop="business_license_address"><el-input v-model="form.business_license_address" placeholder="请输入营业执照住所" class="max-w460"></el-input></el-form-item>

      <el-form-item label="营业执照经营范围" prop="business_license_scope"><el-input v-model="form.business_license_scope" type="textarea" :rows="3" placeholder="请输入营业执照经营范围" class="max-w460"></el-input></el-form-item>

      <el-form-item label="备注" prop="remark"><el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" class="max-w460"></el-input></el-form-item>

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</el-dialog>
  
</template>

<script>
import Ma_companyApi from '@/api/ma_company.js';
import Ma_organizationApi from '@/api/ma_organization.js';
import UserApi from '@/api/user.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      companyTypeOptions: [
        {
          value: '有限责任公司',
          label: '有限责任公司',
          children: [
            {
              value: '自然人独资',
              label: '自然人独资',
              children: [
                { value: '有限责任公司（自然人独资）', label: '有限责任公司（自然人独资）' },
                { value: '有限责任公司（自然人投资或控股）', label: '有限责任公司（自然人投资或控股）' }
              ]
            },
            {
              value: '法人独资',
              label: '法人独资',
              children: [
                { value: '有限责任公司（法人独资）', label: '有限责任公司（法人独资）' },
                { value: '有限责任公司（非自然人投资或控股的法人独资）', label: '有限责任公司（非自然人投资或控股的法人独资）' }
              ]
            },
            {
              value: '国有独资',
              label: '国有独资',
              children: [
                { value: '有限责任公司（国有独资）', label: '有限责任公司（国有独资）' }
              ]
            },
            {
              value: '其他',
              label: '其他',
              children: [
                { value: '有限责任公司（自然人投资或控股）', label: '有限责任公司（自然人投资或控股）' },
                { value: '有限责任公司（非自然人投资或控股）', label: '有限责任公司（非自然人投资或控股）' }
              ]
            }
          ]
        },
        {
          value: '股份有限公司',
          label: '股份有限公司',
          children: [
            {
              value: '上市',
              label: '上市',
              children: [
                { value: '股份有限公司（上市）', label: '股份有限公司（上市）' },
                { value: '股份有限公司（上市、自然人投资或控股）', label: '股份有限公司（上市、自然人投资或控股）' }
              ]
            },
            {
              value: '非上市',
              label: '非上市',
              children: [
                { value: '股份有限公司（非上市）', label: '股份有限公司（非上市）' },
                { value: '股份有限公司（非上市、自然人投资或控股）', label: '股份有限公司（非上市、自然人投资或控股）' }
              ]
            }
          ]
        },
        {
          value: '个人独资企业',
          label: '个人独资企业',
          children: [
            {
              value: '普通',
              label: '普通',
              children: [
                { value: '个人独资企业', label: '个人独资企业' }
              ]
            }
          ]
        },
        {
          value: '合伙企业',
          label: '合伙企业',
          children: [
            {
              value: '普通合伙',
              label: '普通合伙',
              children: [
                { value: '普通合伙企业', label: '普通合伙企业' }
              ]
            },
            {
              value: '有限合伙',
              label: '有限合伙',
              children: [
                { value: '有限合伙企业', label: '有限合伙企业' }
              ]
            }
          ]
        },
        {
          value: '集体企业',
          label: '集体企业',
          children: [
            {
              value: '城镇集体',
              label: '城镇集体',
              children: [
                { value: '城镇集体所有制企业', label: '城镇集体所有制企业' }
              ]
            },
            {
              value: '乡村集体',
              label: '乡村集体',
              children: [
                { value: '乡村集体所有制企业', label: '乡村集体所有制企业' }
              ]
            }
          ]
        },
        {
          value: '国有企业',
          label: '国有企业',
          children: [
            {
              value: '全民所有制',
              label: '全民所有制',
              children: [
                { value: '全民所有制企业', label: '全民所有制企业' }
              ]
            },
            {
              value: '国有独资公司',
              label: '国有独资公司',
              children: [
                { value: '国有独资公司', label: '国有独资公司' }
              ]
            }
          ]
        },
        {
          value: '外资企业',
          label: '外资企业',
          children: [
            {
              value: '外商投资',
              label: '外商投资',
              children: [
                { value: '外商投资企业', label: '外商投资企业' },
                { value: '中外合资经营企业', label: '中外合资经营企业' },
                { value: '中外合作经营企业', label: '中外合作经营企业' },
                { value: '外商独资企业', label: '外商独资企业' }
              ]
            }
          ]
        },
        {
          value: '其他',
          label: '其他',
          children: [
            {
              value: '其他类型',
              label: '其他类型',
              children: [
                { value: '其他企业', label: '其他企业' }
              ]
            }
          ]
        }
      ],
      cascaderProps: {
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: true,
        value: 'value',
        label: 'label',
        children: 'children'
      },
      lock_city: true,
      lock_region: true,
      province_options: [],
      city_options: [],
      region_options: [],
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        organization_type: '企业',
        main_account: '',
        transport_license_image: [],
        transport_license_no: '',
        transport_license_validity_start: '',
        transport_license_validity_end: '',
        transport_license_issue_date: '',
        transport_license_scope: '',
        business_license_image: [],
        business_license_name: '',
        registered_capital: '',
        credit_code: '',
        company_type: [],
        establishment_date: '',
        valid_start_date: '',
        valid_end_date: '',
        legal_representative: '',
        legal_phone: '',
        legal_id_card: '',
        safety_manager: '',
        safety_manager_phone: '',
        organization_name: '',
        short_name: '',
        province_id: '',
        province_name: '',
        city_id: '',
        city_name: '',
        region_id: '',
        region_name: '',
        business_license_address: '',
        business_license_scope: '',
        remark: '',
        sort: 50
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
      },
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getAddressList();
    this.getDetail();
  },
  props: ["open_add","ma_company_id"],
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },

    getDetail() {
      let self = this;
      Ma_companyApi.detail({ma_company_id: self.ma_company_id},true).then(res => {
          self.form.name = res.data.name;
          self.form.organization_type = res.data.organization_type;
          self.form.main_account = res.data.main_account;
          self.form.transport_license_image = res.data.transport_license_image || [];
          self.form.transport_license_no = res.data.transport_license_no;
          self.form.transport_license_validity_start = res.data.transport_license_validity_start;
          self.form.transport_license_validity_end = res.data.transport_license_validity_end;
          self.form.transport_license_issue_date = res.data.transport_license_issue_date;
          self.form.transport_license_scope = res.data.transport_license_scope;
          self.form.business_license_image = res.data.business_license_image || [];
          self.form.business_license_name = res.data.business_license_name;
          self.form.registered_capital = res.data.registered_capital;
          self.form.credit_code = res.data.credit_code;
          self.form.company_type = self.findCompanyTypePath(res.data.company_type);
          self.form.establishment_date = res.data.establishment_date;
          self.form.valid_start_date = res.data.valid_start_date;
          self.form.valid_end_date = res.data.valid_end_date;
          self.form.legal_representative = res.data.legal_representative;
          self.form.legal_phone = res.data.legal_phone;
          self.form.legal_id_card = res.data.legal_id_card;
          self.form.safety_manager = res.data.safety_manager;
          self.form.safety_manager_phone = res.data.safety_manager_phone;
          self.form.organization_name = res.data.organization_name;
          self.form.short_name = res.data.short_name;
          if (res.data.province_id > 0) {
            self.lock_city = false
            self.form.province_name = res.data.province_name
            self.form.province_id = res.data.province_id
            self.cityList(res.data.province_id)
          }
          if (res.data.city_id > 0) {
            self.lock_region = false
            self.form.city_name = res.data.city_name
            self.form.city_id = res.data.city_id
            self.form.region_name = res.data.region_name
            self.form.region_id = res.data.region_id
            self.regionList(res.data.city_id);
          }
          self.form.business_license_address = res.data.business_license_address;
          self.form.business_license_scope = res.data.business_license_scope;
          self.form.remark = res.data.remark;
          self.form.sort = res.data.sort;
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      form.ma_company_id = self.ma_company_id;
      if (Array.isArray(form.company_type) && form.company_type.length > 0) {
        form.company_type = form.company_type[form.company_type.length - 1];
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_companyApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /* 省份获取 */
    getAddressList() {
      let self = this;
      UserApi.provinceList('', true)
        .then(data => {
          self.province_options = data.data.list;
        })
        .catch(error => {

        });
    },

    /* 市列表 */
    cityList(id) {
      let self = this;
      let Params = {}
      Params.province_id = id
      UserApi.city_list(Params, true)
        .then(data => {
          self.city_options = data.data.list
        })
        .catch(error => {

        });
    },

    /* 区列表 */
    regionList(id) {
      let self = this;
      let Params = {}
      Params.region_id = id
      UserApi.region_list(Params, true)
        .then(data => {
          self.region_options = data.data.list
        })
        .catch(error => {

        });
    },

    /* 选择省 */
    provinceChange(selVal) {
      let self = this
      self.form.province_name = selVal.name
      self.form.province_id = selVal.id
      self.form.city_name = ""
      self.form.city_id = ""
      self.form.region_id = ""
      self.lock_city = false
      if (!self.lock_region) {
        self.lock_region = true
        self.form.region_name = ""
      }
      self.cityList(selVal.id)
    },

    /* 选择市 */
    cityChange(selVal) {
      let self = this
      self.form.city_name = selVal.name
      self.form.city_id = selVal.id
      self.form.region_name = ""
      self.form.region_id = ""
      if (self.lock_region) {
        self.lock_region = false
      }
      self.regionList(selVal.id);
    },

    /* 选择区 */
    regionChange(selVal) {
      let self = this
      self.form.region_name = selVal.name
      self.form.region_id = selVal.id
      self.$forceUpdate();
    },

    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*根据企业类型值查找完整路径*/
    findCompanyTypePath(value) {
      if (!value) return [];
      
      const findPath = (options, targetValue, path = []) => {
        for (const option of options) {
          const currentPath = [...path, option.value];
          if (option.value === targetValue) {
            return currentPath;
          }
          if (option.children && option.children.length > 0) {
            const result = findPath(option.children, targetValue, currentPath);
            if (result) return result;
          }
        }
        return null;
      };
      
      const path = findPath(this.companyTypeOptions, value);
      return path || [];
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = true;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          if (!imgExpt.includes(ext)) {
            prevent = false;
          }
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form[this.code].concat(e);
        this.$set(this.form, this.code, imgs);
      }
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index, code) {
      this.form[code].splice(index, 1);
    }
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_company/index/part/edit.vue